import { createStyles, makeStyles, Theme } from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'
import { useI18nSelector } from 'v3/context/i18n'
import { i18nKey, i18nState } from '../../reducers/i18n'
import { categorySelector } from '../../selectors/location'
import { AppState } from '../../store'
import './Loading.scss'
import { moduleSelector } from '../../selectors'

export const Loading = (props: MapProps) => {
  const i18n = useI18nSelector()

  // Title and message props can be explicity null to prevent the field
  // from rendering at all, and undefined to accept the default
  const { category, module } = props
  let title = props.title
  if (typeof title === 'undefined') {
    if (module || category) {
      title = i18n(`loading.messages.${module || category}.title` as i18nKey)
    } else {
      title = i18n(`loading.messages.app-loading.title`)
    }
  }

  let message = props.message
  if (typeof message === 'undefined') {
    if (module || category) {
      message = i18n(`loading.messages.${module || category}.message` as i18nKey)
    } else {
      message = i18n(`loading.messages.app-loading.message`)
    }
  }

  const classes = ['loader-root']
  if (props.fullScreen) {
    classes.push('full-screen')
  }

  return (
    <div className={classes.join(' ')}>
      <div className="loader" />
      <div className="message-wrapper">
        {title && <h2 className="title">{title}</h2>}
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  )
}

type MapProps = {
  title?: string | null
  message?: string | null
  module?: string
  category?: string
  fullScreen?: boolean
}
const mapProps = (state: AppState): any => ({
  category: categorySelector(state),
  module: moduleSelector(state),
})

export default connect<MapProps, any, any, AppState>(mapProps)(Loading)
